import type { NowPlayingTrack } from '../native/music-listener-native';

export function NowPlayingChip({ track, className, tone = 'light' }: {
    track: NowPlayingTrack | null;
    className?: string;
    tone?: 'light' | 'dark';
}) {
    if (!track) return null;

    const stateClass =
        track.state === 'playing' ? 'bg-success' :
        track.state === 'paused' ? 'bg-surface/50' :
        'bg-line';
    const shellClass = tone === 'dark'
        ? 'border-cockpit-panel/10 bg-cockpit-panel/[0.07] text-cockpit-text'
        : 'border-line bg-surface/90 text-text shadow-sm';
    const metaClass = tone === 'dark' ? 'text-cockpit-muted' : 'text-muted';

    return (
        <div className={`min-w-0 rounded-lg border px-3 py-2 text-sm ${shellClass} ${className ?? ''}`}>
            <div className="flex min-w-0 items-center gap-2">
                <span className={`h-2 w-2 shrink-0 rounded-full ${stateClass}`} aria-hidden />
                <span className="min-w-0 truncate font-semibold">{track.title || track.artist}</span>
            </div>
            <div className={`min-w-0 truncate text-xs ${metaClass}`}>
                {[track.artist, track.album, track.appLabel].filter(Boolean).join(' - ')}
            </div>
        </div>
    );
}

export function NowPlayingPermissionCard({ supported, enabled, loading, onOpenSettings, onRefresh }: {
    supported: boolean;
    enabled: boolean;
    loading: boolean;
    onOpenSettings: () => void;
    onRefresh: () => void;
}) {
    if (!supported || enabled) return null;

    return (
        <div className="mt-3 rounded-lg border border-line bg-surface-raised p-3 text-sm">
            <div className="font-medium mb-1">Now playing</div>
            <p className="muted text-xs mb-3">
                Enable Android notification listener access to show local media-session metadata in Drive.
            </p>
            <div className="flex gap-2">
                <button type="button" className="btn-secondary py-2 text-sm" onClick={onOpenSettings}>
                    Open settings
                </button>
                <button type="button" className="btn-secondary py-2 text-sm" onClick={onRefresh} disabled={loading}>
                    {loading ? 'Checking...' : 'Check'}
                </button>
            </div>
        </div>
    );
}
